<app-ice-select-box
  class="additional-service-select"
  type="checkbox"
  [control]="selectionControl"
  [disabled]="selectionControl?.disabled"
  [label]="mutexSet.name"
  [reserveSpaceForInfoText]="true"
  [value]="mutexSet.name"
>
  @if (isSelected) {
    <div class="mutex-content">
      <mat-radio-group class="mutex-services-list" [formControlName]="mutexControlName">
        @for (mutexService of mutexSet.mutexServices; track mutexService.productId + $index) {
          <mat-radio-button class="mutex-radio-button" [value]="mutexService.productId">
            <div class="mutex-service-description">
              <span>{{ mutexService.description }}</span>
              @if (mutexService.price) {
                <span class="price">
                  {{ mutexService.price?.includingVAT | priceFormat: PriceType.Monthly }}
                </span>
              }
            </div>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }
</app-ice-select-box>
